import dynamic from 'next/dynamic';
import { GeneralMessageProps } from './GeneralMessage.types';

export const GeneralMessage = dynamic<{ model: GeneralMessageProps }>(() =>
  import('./GeneralMessage').then(mod => mod.GeneralMessage)
);
